import React, { ReactElement, useEffect, useLayoutEffect, useRef } from 'react'
import styles from './App.module.scss'
import { NavigationBar } from './components/navigation-bar/NavigationBar'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { FightbackRoutes } from './config/routeConfig'
import { Footer } from './components/footer/Footer'
import { ROUTES } from './config/routes'
import { CookieBanner } from './components/cookie-banner/CookieBanner'
import { CookieConsentProvider } from './provider/CookieConsentProvider'

interface ScrollProps {
  children: ReactElement
  disableScrollOnCondition?: (prevPath: string, currentPath: string) => boolean
}

const ScrollOnNavigate = ({ children, disableScrollOnCondition }: ScrollProps): ReactElement => {
  const location = useLocation()
  const prevPath = useRef(location.pathname)
  const prevAction = useRef(location.state)

  useEffect(() => {
    prevAction.current = location.state
  }, [location.state])

  useLayoutEffect(() => {
    const currentPath = location.pathname

    const shouldScroll = disableScrollOnCondition
      ? !disableScrollOnCondition(prevPath.current, currentPath)
      : true

    console.log(prevAction)

    if (shouldScroll && !prevAction.current) {
      document.documentElement.scrollTo(0, 0)
    }

    prevPath.current = currentPath
  }, [location.pathname, disableScrollOnCondition])

  return children
}

const disableScrollOnCondition = (prevPath: string, currentPath: string): boolean => {
  // Disable scroll when navigating back from ROUTES.wrestler to ROUTES.roster
  return prevPath.includes(ROUTES.wrestler) && currentPath === ROUTES.roster
}

function App(): ReactElement {
  return (
    <div className={styles.background}>
      <div className={styles.app}>
        <CookieConsentProvider>
          {/* eslint-disable-next-line camelcase */}
          <BrowserRouter future={{ v7_startTransition: true }}>
            <NavigationBar />
            <main className={styles.content}>
              <ScrollOnNavigate disableScrollOnCondition={disableScrollOnCondition}>
                <FightbackRoutes />
              </ScrollOnNavigate>
            </main>
            <Footer />
            <CookieBanner />
          </BrowserRouter>
        </CookieConsentProvider>
      </div>
    </div>
  )
}

export default App
